import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LoaderModule } from '®shared/loader';

import { SectionModeResolverComponent } from './section-mode-resolver.component';

@NgModule({
  imports: [CommonModule, LoaderModule, RouterModule],
  declarations: [SectionModeResolverComponent],
  exports: [SectionModeResolverComponent],
})
export class SectionModeResolverModule {}
